export const endpoints = {
  getFamilyGroupAdminView: () => 'api/product/FamilyGroups?$count=true',
  getFamilyGroupMasterData: () => 'api/familygroup/Familygroups',
  getFamilyGroupData: () => 'api/familygroup/Familygroups?$count=true',
  getProductData: () => 'api/product/Products?$count=true',
  searchProductData: () => `api/product/Products/search`,
  updateFamilyGroupAdmin: () => 'api/product/FamilyGroups/UpdateMultipleProducts',
  updateFamilyGroup: (id: string) => `api/familygroup/FamilyGroups/${id}`,
  updateProduct: (id: string) => `api/product/Products/${id}`,
  familyGroup: () => `api/familygroup/FamilyGroups`,
  missingFamilyGroup: () => `api/familygroup/FamilyGroups`,
  deleteFamilyGroup: (Id: string) => `api/familygroup/FamilyGroups/${Id}`,

  //File Upload endpoints Start
  uploadHistorys: () => 'api/fileupload/UploadHistorys',
  uploadHistorysById: (fileId: string) => `api/fileupload/downlaod/${fileId}`,
  uploadProduct: () => `api/fileupload/Uploads/Product`,
  uploadFamilyGroup: () => `api/fileupload/Uploads/FamilyGroup`,

  //File Download endpoints
  downloadFamilyGroup: () => `api/Product/ExtractFamilyGroups`,
  downloadProduct: () => `api/Product/ExtractProducts`,

   // LDM Scan App Endpoint
   downloadLDMApp: () => `api/v1/cubiscanupdate/download`,

  //Container Type maintenance
  getDuType: () => `api/dutypemaintenance/DuTypeMaintenances`,
  createDuTpe: () => `api/dutypemaintenance/DuTypeMaintenances`,
  getDuTypePaginated: () => `api/dutypemaintenance/DuTypeMaintenances?$count=true&OrderBy=createdDate desc`,
  getDuTypeByIdx: (Id: string) => `api/dutypemaintenance/DuTypeMaintenances/${Id}`,
  updateDuTypeByIdx: (Id: string) => `api/dutypemaintenance/DuTypeMaintenances/${Id}`,
  deleteDuType: (Id: string) => `api/dutypemaintenance/DuTypeMaintenances/${Id}`,

  getResult: (path: string) => `api/${path}`,
}